import React, { useEffect, useContext, useState } from "react";
import { FarmerContext } from "./FarmerContext";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser} from '@fortawesome/free-solid-svg-icons';
export default function FarmerCustomers() {
  const { data, availableCustomers, formik, setRelToDel,  } = useContext(FarmerContext)
  const farmerCustomerNames = availableCustomers.length>0? availableCustomers.map((customer) => customer.username):[]
  // console.log( farmerCustomerNames)
  return (
    <div className="bg-gray-100 mt-2  mb-16">
      <div>
        <div>
           <Link to="/FarmerDash/communicate/customers">Communicate</Link>
        </div>
      </div>
      <p className="font-bold">CUSTOMERS</p>
           <div>
             {data[0]?.Customers?.length > 0 ? (
               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 border border-gray-100">
                 {data[0].Customers.map((customer, index) => (
                   <div key={index} className="relative">
                     <div className="max-w-[100px] mx-auto mb-10 block">
                       <FontAwesomeIcon
                         icon={faUser}
                         className="w-full h-auto max-w-[250px] min-w-fit mx-auto mb-10 block"
                         style={{ maxWidth: "100px" }} // Ensure the max width is 250px
                       />
                     </div>
                     <div className="absolute top-0 left-0 right-0 z-10 flex flex-row justify-between p-2 text-sm">
                       <p className="text-gray-900 bg-white rounded-lg">{customer.username}</p>
                       <form onSubmit={formik.handleSubmit}>
                         <button
                           className="bg-blue-500 rounded-full px-2 py-1 text-white"
                           type="submit"
                           onClick={(e) => {
                             setRelToDel(true);
                             formik.setFieldValue("name", customer.username);
                           }}
                         >
                           DELETE
                         </button>
                       </form>
                     </div>
                   </div>
                 ))}
               </div>
             ) : (
               <p>It seems you have no farmers. Want to add one?</p>
             )}
           </div>

      {farmerCustomerNames.length>0?
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="name">Select a customer to add</label>
          <select onChange={formik.handleChange} value={formik.name}
            name="name" id="name" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
            <option value="">Select a customer</option>
            {farmerCustomerNames.map((customer, index) => (
              <option value={customer} key={customer.id}>{customer}</option>
            ))}
          </select>
          <button type="submit" className="bg-blue-500 rounded-lg text-white disabled:opacity-50" disabled={formik.isSubmitting || !formik.isValid}>Send request</button>
        </form>
        : null}
    </div>
  )
}